import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InputJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { DateTime } from 'luxon';
import { Moment } from 'moment';
import { merge, Observable, Subscription } from 'rxjs';

import it from './i18n/input-date-time-session.it.json';

@Component({
  templateUrl: './input-date-time-session.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputDateTimeSessionComponent implements OnInit, OnDestroy {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  inputForm: FormGroup = this.fb.group({
    date: [undefined, [Validators.required]],
    hour: [undefined, [Validators.required]],
    minute: [undefined, [Validators.required]],
    second: [undefined, [Validators.required]]
  });

  private subs = new Subscription();

  constructor(
    private fb: FormBuilder,
    private translocoSvc: TranslocoService
  ) { }

  ngOnInit(): void {
    this.translocoSvc.setTranslation(it, 'it');
    const fnFormat = (v: string, max: number) => {
      let n = !isNaN(+v) ? +v : 0;
      if (n < 0) {
        n = 0;
      }
      if (n > max) {
        n = max;
      }
      return n.toString().padStart(2, '0');
    };
    this.subs.add(this.inputForm.get('hour')?.valueChanges.subscribe(v => this.inputForm.get('hour')?.setValue(fnFormat(v, 23), { emitEvent: false })));
    this.subs.add(this.inputForm.get('minute')?.valueChanges.subscribe(v => this.inputForm.get('minute')?.setValue(fnFormat(v, 59), { emitEvent: false })));
    this.subs.add(this.inputForm.get('second')?.valueChanges.subscribe(v => this.inputForm.get('second')?.setValue(fnFormat(v, 59), { emitEvent: false })));
  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  submit() {
    if (!this.inputForm.invalid) {
      const now = DateTime.local();
      const { date, hour, minute, second } = this.inputForm.value;
      const d = DateTime.fromISO((date as Moment).toISOString()).set({ hour, minute, second });
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now.toJSDate(),
        type: SessionStepValueType.inputDateTime,
        value: { input: d.toJSDate() } as InputJson
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now.toJSDate(), values: [value] });
    }
  }

}
